import Api from "./Api";
import { debugLog } from "../../utils/debug";

export async function fetchAvailableTemplates() {
    return Api.get(`/service-plan/templates/available`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error fetching available service plan templates: " + error.message);
            return null;
        });
}

export async function savePlaylistAsTemplate(playlistId, dto) {
    return Api.post(`/service-plan/${playlistId}/save-as-template`, dto)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error saving service plan as template: " + error.message);
            return null;
        });
}

export async function fetchMyTemplates() {
    return Api.get(`/api/my/service-plan-templates`)
        .then(res => res.data || [])
        .catch(error => {
            debugLog("Error fetching my service plan templates: " + error.message);
            return [];
        });
}

export async function createBlankTemplate(dto) {
    return Api.post(`/api/my/service-plan-templates`, dto)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error creating blank service plan template: " + error.message);
            return null;
        });
}

export async function updateTemplate(templateId, dto) {
    return Api.put(`/api/my/service-plan-templates/${templateId}`, dto)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error updating service plan template: " + error.message);
            return null;
        });
}

export async function updateTemplateItems(templateId, items) {
    return Api.put(`/api/my/service-plan-templates/${templateId}/items`, items)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error updating service plan template items: " + error.message);
            return null;
        });
}

export async function deleteTemplate(templateId) {
    return Api.delete(`/api/my/service-plan-templates/${templateId}`)
        .then(res => res.status === 204)
        .catch(error => {
            debugLog("Error deleting service plan template: " + error.message);
            return false;
        });
}

export async function duplicateTemplate(templateId) {
    return Api.post(`/api/my/service-plan-templates/${templateId}/duplicate`)
        .then(res => res.data)
        .catch(error => {
            debugLog("Error duplicating service plan template: " + error.message);
            return null;
        });
}
